module.exports = __webpack_public_path__ + "static/img/4.6e26e6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/sp/4.png
// module id = Cy+N
// module chunks = 0